import { render, staticRenderFns } from "./LayoutWithdrawal.vue?vue&type=template&id=8e2c2748&scoped=true"
import script from "./LayoutWithdrawal.vue?vue&type=script&lang=js"
export * from "./LayoutWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./LayoutWithdrawal.vue?vue&type=style&index=0&id=8e2c2748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2c2748",
  null
  
)

export default component.exports